export default __webpack_public_path__ + "static/media/Parallax2.701b079d.jpg";